<template>
  <div>
    <img :src="logo" :alt="name" class="img-logo" v-if="validUrl" />
  </div>
</template>

<script>
export default {
  props: {
    logo: {
      type: String,
    },

    name: {
      type: String,
    },
  },
  computed: {
    validUrl() {
      const pattern = /(http[s]?:\/\/.*\.(?:png|jpg|gif|svg|jpeg))/i;
      const valid = pattern.test(this.logo);

      return valid;
    },
  },
};
</script>

